import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';

@Component({
  selector: 'app-signout-redirect-callback',
  standalone: true,
  imports: [],
  template: `<div></div>`,
  styles: ``
})
export class SignoutRedirectCallbackComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) { }
  ngOnInit(): void {
    this.authService.finishLogout().then((value) => {
      this.router.navigate([''], { replaceUrl: true });
    })
  }
}
